import React, { useState } from 'react';
import ReportDownloadButton from '../ReportDownloadButton';
import { HGTable, TableSkeleton } from 'components/HGTable';
import ReportStatus from '../ReportStatus';
import { useReports } from '../service';
import NoDataAvailable from 'components/NoDataAvailable';

const reportsTableColumns = [
    {
        Header: 'Status',
        accessor: 'Status',
        component: (item) => (
            <ReportStatus statusText={item?.Status}></ReportStatus>
        ),
    },
    {
        Header: 'Report View',
        accessor: 'ReportView',
    },
    {
        Header: 'Requested At',
        accessor: 'Requested_At',
    },
    {
        Header: 'Report Start',
        accessor: 'Start_Date',
    },
    {
        Header: 'Report End',
        accessor: 'End_Date',
    },
    {
        Header: 'Download',
        accessor: 'S3Key',
        component: (item) => (
            <ReportDownloadButton
                reportStatus={item?.Status}
                fileName={item?.S3Key}
            />
        ),
    },
];

const ReportDownloadList = ({ deviceId }) => {
    const { data: reports, isLoading } = useReports(deviceId);
    const [sortField, setSortField] = useState('');
    const [sortDirection, setSortDirection] = useState(1);

    return (
        <div>
            {isLoading ? (
                <TableSkeleton columns={reportsTableColumns} />
            ) : !reports || reports.length === 0 ? (
                <NoDataAvailable />
            ) : (
                <HGTable
                    columns={reportsTableColumns}
                    data={reports}
                    sortField={sortField}
                    setSortField={setSortField}
                    sortDirection={sortDirection}
                    setSortDirection={setSortDirection}
                    currentPage={1}
                    setCurrentPage={() => {}}
                    pageSize={reports.length}
                    totalItems={reports.length}
                />
            )}
        </div>
    );
};

export default ReportDownloadList;
